module.exports = __webpack_public_path__ + "0f15507a14e3e87aa40ada52ed57f354.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/city-45.png
 ** module id = 1038
 ** module chunks = 0
 **/